// 22092022 Hannu Moijanen:
// Added logging library to be used
import pino from "pino";

export default pino({
    level: process.env.LOG_LEVEL || (process.env.REACT_APP_ENV !== "prod" ? "debug" : "info"),
    browser: { asObject: true },
});
